import { Fragment, useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { getArticleList } from "../../../api/blog/blogAPI";
import LoadingPlaceholder from "../../../components/ui/loading/LoadingPlaceholder";
import ArticlePreview from "../../../components/ui/blog/ArticlePreview";

function DecodeBannerArticles({ content }) {
  const [loading, setLoading] = useState(true);
  const [articles, setArticles] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const scrollRef = useRef(null);

  // Define breakpoints
  const isDesktop = windowWidth > 768;
  const isTablet = windowWidth <= 1024 && windowWidth > 469;

  // ONLY triple the articles if we are NOT on desktop
  const displayArticles = !isDesktop
    ? [...articles, ...articles, ...articles]
    : articles;

  async function getArticles() {
    setLoading(true);
    const apiUrl = "blog/article?limit=4";
    try {
      const response = await getArticleList(apiUrl);
      if (response.ok) {
        const responseData = await response.json();
        setArticles((responseData.data || []).slice(0, 4));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Handle the initial middle-set position for infinite scroll
  useEffect(() => {
    if (!isDesktop && articles.length > 0 && scrollRef.current) {
      const container = scrollRef.current;
      const itemWidth = container.offsetWidth / (isTablet ? 2 : 1);
      container.scrollLeft = articles.length * itemWidth;
    }
  }, [articles, isDesktop, isTablet]);

  const handleScroll = () => {
    if (isDesktop || !scrollRef.current || articles.length === 0) return;

    const { scrollLeft, offsetWidth, scrollWidth } = scrollRef.current;
    const viewSize = isTablet ? 2 : 1;
    const itemWidth = offsetWidth / viewSize;

    const index = Math.round(scrollLeft / itemWidth) % articles.length;
    setActiveIndex(index);

    // Silent Loop Reset
    if (scrollLeft <= 5) {
      scrollRef.current.scrollLeft = scrollLeft + articles.length * itemWidth;
    } else if (scrollLeft >= scrollWidth - offsetWidth - 5) {
      scrollRef.current.scrollLeft = scrollLeft - articles.length * itemWidth;
    }
  };

  useEffect(() => {
    getArticles();
  }, []);

  // Dot Calculation: 2 dots for Tablet (2 per page), 4 for Mobile (1 per page)
  const dotCount = isTablet ? 2 : 4;
  const activeDot = isTablet ? Math.floor(activeIndex / 2) : activeIndex;

  return (
    <Fragment>
      <div className="decode-banner-container">
        <div className="decode-banner-header">
          <h2>{content.heading}</h2>
        </div>
        {!loading && (
          <div className="decode-banner-content">
            <div
              className="banner-article-grid"
              ref={scrollRef}
              onScroll={handleScroll}
            >
              {displayArticles.map((article, idx) => (
                <div
                  className="article-card-wrapper"
                  key={`${article.id}-${idx}`}
                >
                  <ArticlePreview
                    article_id={article.id}
                    creative_url={article.creative}
                    title={article.title}
                  />
                </div>
              ))}
            </div>

            {!isDesktop && (
              <div className="blog-pagination">
                {Array.from({ length: dotCount }).map((_, idx) => (
                  <span
                    key={idx}
                    className={`dot-modern ${
                      activeDot === idx ? "active" : ""
                    }`}
                  />
                ))}
              </div>
            )}
          </div>
        )}
        {loading && <LoadingPlaceholder rows={1} type="card-large" />}
        <div className="blog-cta-wrapper">
          <Link to="/blog" className="cta-button secondary">
            {content.cta}
          </Link>
        </div>
      </div>
    </Fragment>
  );
}
export default DecodeBannerArticles;
